module.exports = __webpack_public_path__ + "static/media/card-Charlie-inactive.1dc1a1c9.svg";